export function videoBlock() {
	$(document).on("click", ".video-holder .play-video", function (e) {
		e.preventDefault();
		let parent = $(this).parents(".video-holder");
		let src = parent.attr("data-iframe-src");
		let iframe = parent.find("iframe")[0];
		iframe.src = src;
		parent.addClass("video-open");
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoBlock.js